import appAxios from '../../utils/appAxios.js';


export default {
    namespaced: true,

    state: {
        answerTemplate: null,
        answerTemplateList: [],
        answerStateList: [],

        loading: false,
        recordsTotal: 0,

    },
    getters: {
        _getAnswerTemplateList: (state) => {
            return state.answerTemplateList
        },
        _getAnswerStateList: (state) => {
            return state.answerStateList
        },
        _getTotalRecords: (state) => {

            return state.recordsTotal
        },
        _getLoading: (state) => { return state.loading }
    },
    mutations: {
        SET_ANSWERS_TEPMLATE_LIST(state, data) {

            state.answerTemplateList = []
            data.ListItems.forEach(value => {

                let item = {
                    id: value.Id,
                    answerText: value.AnswerText,
                    notScorable: value.NotScorable,
                    type: value.Type,
                    locales: value.Locales,
                    actionRequired: value.ActionRequired,
                    mediaProofRequired: value.MediaProofRequired,
                    noteProofRequired: value.NoteProofRequired,
                    answerStateId: value.AnswerStateId
                }
                state.answerTemplateList.push(item)
            });

            state.recordsTotal = data.TotalItemsCount
            state.loading = false;
        },

        SET_ANSWERS_STATE_LIST(state, data) {
            state.answerStateList = []
            data.ListItems.forEach(value => {

                let item = {
                    id: value.Id,
                    locales: value.Locales,
                    name: value.Name

                }
                state.answerStateList.push(item)
            });

        }
    },
    actions: {

        async GET_ALL_ANSWERS_TEMPLATE({ commit, state }, payload) {

            state.loading = true;
            await appAxios.post("/admin/Answer/GetAllAnswerTemplate", payload).then(response => {
                if (response.data.Success) {
                    commit("SET_ANSWERS_TEPMLATE_LIST", response.data.Data)
                }
            }).catch(() => state.loading = false)
        },

        async ADD_ANSWER_TEMPLATE(context, payload) {
            await appAxios.post("/admin/Answer/CreateAnswerTemplate", payload).then(response => {
                context.dispatch("GET_ALL_ANSWERS_TEMPLATE", { page: 1, pageSize: 10 })
            })

        },

        async DELETE_ANSWER_TEMPLATE(context, payload) {
            await appAxios.post("/admin/Answer/DeleteAnswerTemplates", payload[0]).then(response => {
                context.dispatch("GET_ALL_ANSWERS_TEMPLATE", payload[1])
            })
        },

        async UPDATE_ANSWER_TEMPLATE(context, payload) {
            await appAxios.post("/admin/Answer/UpdateAnswerTemplate", payload).then(response => {
                context.dispatch("GET_ALL_ANSWERS_TEMPLATE", { page: 1, pageSize: 10 })
            }
            )

        },
    }

}